import React, { useState } from 'react';
import KjsList from './KjsList';
import { withRouter } from 'react-router-dom';
import KjsFilter from '../Kjs/Filter/KjsFilter';
import { numberOfItemsPerPage } from '../../constants/globals.js';

const Kjs = (props) => {
  const initialStateValues = {
    createdAtFrom: Date.now(),
    createdAtTo: Date.now(),
  };

  const [filters, setFilters] = useState(initialStateValues);
  const [postData, setPostData] = useState(null);
  const [resetData, setResetData] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(numberOfItemsPerPage);

  return (
    <div className="wrapper-fade-in content-min-height mb-5 mt-2">
      <div className="container">
        <KjsFilter
          saveFilters={(filters) => setFilters(filters)}
          initialValues={filters}
          initialStateValues={initialStateValues}
          savePostData={(postData) => setPostData(postData)}
          setResetData={setResetData}
          pageSize={pageSize}
        />
        <KjsList
          postData={postData}
          resetData={resetData}
          setResetData={setResetData}
          syncLoadingStop={props.syncLoadingStop}
          syncLoadingStart={props.syncLoadingStart}
          activePage={activePage}
          pageSize={pageSize}
          setActivePage={setActivePage}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default withRouter(Kjs);
